export default {
    FINISHED   : "FINISHED",
    UNFINISHED : "UNFINISHED",
    PROCESSING : "PROCESSING",
    PENDING: "PENDING"
};